import type { PropsWithChildren } from "react";

import Card from "../Card";

export default function ListFrame(props: PropsWithChildren) {
    const { children } = props;
    return <Card>{children}</Card>;
}
